import React from "react";
import SmartTable from "components/ui_components/table/SmartTable";
import helpers from "utils/helpers";

const tableColById = [
  "hdl",
  "trig",
  "trigHdlCRatio",
  "vLdlC",
  "cholHdl",
  "nonHdlC",
  "totalChol",
  "apoB",
  "lp",
  "pulsScore",
  "puls",
];

const tableColByHash = {
  hdl: {
    label: "HDL",
  },
  trig: {
    label: "Triglycerides",
  },
  trigHdlCRatio: {
    label: "Trig/HDL-C*",
  },
  vLdlC: {
    label: "vLDL-C*",
  },
  cholHdl: {
    label: "Chol / HDL*",
  },
  nonHdlC: {
    label: "Non-HDL-C*",
  },
  totalChol: {
    label: "Total Chol",
  },
  apoB: {
    label: "ApoB",
  },
  lp: {
    label: "Lp(a)",
  },
  puls: {
    label: "SVDx",
  },
  pulsScore: {
    label: "SVDx Score",
  },
};

const ResultedTestsSubTable = ({ reqID }) => {
  return (
    <SmartTable
      resource={`requisitions/${reqID}/req_resulted_tests`}
      orderBy="reqId"
      columns={helpers.byHashByIDConfToArray(tableColById, tableColByHash)}
      isSubTable={true}
      showSelect={false}
      showPagination={false}
    />
  );
};

export default ResultedTestsSubTable;
